export default __webpack_public_path__ + "static/media/NDTV.f0d23c48.png";